import React from 'react';

import Filters from '../Filters';
import TableGames from '../../../Games/TableGames';

const TeamGamesTab = () => {
  return (
    <>
      <Filters />
      <div className="games-body" style={{ height: 'calc(100vh - 175px)' }}>
        <TableGames />
      </div>
    </>
  );
};

export default TeamGamesTab;
